interface CarouselItem {
  image: string;
  tag: string;
  title: string;
  desc: string;
}

const carouselItems: CarouselItem[] = [
  {
    image: "https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20warriors%20clashing%20in%20a%20fantasy%20world%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20golden%20explosions%2C%20Japanese%20anime%20art%20style%2C%20cinematic%20composition%2C%20intense%20action%2C%20professional%20illustration&width=900&height=500&seq=carousel-anime-01&orientation=landscape",
    tag: '夏季新番',
    title: '2026夏季新番追番日历',
    desc: '7月新番全面开播！热血、恋爱、奇幻三大赛道全解析，每周更新时间表一目了然，收藏追更不迷路。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20animation%20art%20with%20ancient%20palace%20and%20floating%20lotus%20flowers%2C%20traditional%20ink%20wash%20painting%20style%2C%20golden%20and%20jade%20green%20color%20palette%2C%20mystical%20atmosphere%2C%20cinematic%20lighting&width=900&height=500&seq=carousel-anime-02&orientation=landscape",
    tag: '国漫崛起',
    title: '国漫精品：从水墨到3A大作',
    desc: '盘点2026上半年最值得看的国漫作品，从传统水墨风到电影级3D渲染，国产动画正在创造新高度。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20scene%20with%20elegant%20characters%20in%20a%20cozy%20cafe%20setting%2C%20soft%20peach%20and%20warm%20coral%20lighting%2C%20intimate%20atmosphere%2C%20clean%20modern%20aesthetic%2C%20professional%20illustration&width=900&height=500&seq=carousel-anime-03&orientation=landscape",
    tag: '韩漫精选',
    title: '韩漫爆款工厂：从恋爱到奇幻',
    desc: '为什么韩漫能风靡全球？从恋爱甜宠到奇幻史诗，解锁韩漫的多元魅力与顶级叙事。',
  },
  {
    image: "https://readdy.ai/api/search-image?query=Retro%20anime%20collage%20with%20classic%2090s%20Japanese%20animation%20characters%2C%20nostalgic%20warm%20film%20grain%20texture%2C%20sunset%20orange%20and%20golden%20tones%2C%20iconic%20scenes%20montage%2C%20clean%20composition%2C%20sentimental%20atmosphere&width=900&height=500&seq=carousel-anime-04&orientation=landscape",
    tag: '经典重温',
    title: '那些年我们追过的神作',
    desc: '经典永不过时！重温影响一代人的动漫神作，从EVA到钢炼，每一部都是青春的回忆。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            精心策划的动漫专题内容，深度解读热门话题
          </p>
        </div>

        {/* All items visible at once, no carousel behavior */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden transition-colors hover:bg-background-200/50 flex flex-col sm:flex-row"
            >
              <div className="sm:w-[240px] md:w-[280px] shrink-0 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full sm:h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  style={{ minHeight: '180px' }}
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap self-start">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}